import request from '@/api/request'

// PAR-Q问卷移动端登录并验证用户
export function LoginCheckUser(data) {
  return request({
    url: '/questionnaire/checkUser',
    method: 'post',
    data: data
  })
}

//PAR-Q问卷查询历史提交数据
export function getDetailByClientUserId(clientUserId) {
  return request({
    url: '/questionnaire/getDetail?clientUserId=' + clientUserId,
    method: 'get'
  })
}

// PAR-Q问卷保存答案
export function QuestionnaireSaveAnswer(data) {
  return request({
    url: '/questionnaire/saveAnswer',
    method: 'post',
    data: data
  })
}

// PAR-Q问卷保存签名（type：1/PAR-Q问卷签名;2/PAR-Q问卷证明人签名;3/PAR-Q问卷父母，监护人，医生签名;）
export function QuestionnaireSubmitSign(data) {
  return request({
    url: '/questionnaire/submitSign?clientUserId=' + data.clientUserId + '&type=' + data.type,
    method: 'post',
    data: data.file
  })
}
